import { SET_TRAVEL_DETAILS } from '../actions/travelDetailsActions';

const initialState = {
  pickupValue: '',
  dropoffValue: '',
  outboundDate: '',
  outboundTime: '',
  adultsCount: 0,
  childrenCount:0,
  infantsCount:0,
  returnDate: '',
  returnTime: '',
};

const travelDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRAVEL_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default travelDetailsReducer;
